"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    fill: "none",
    d: "M0 5.274L4.367 9 13 0"
  }));
}

var MemoSvgCheck = /*#__PURE__*/React.memo(SvgCheck);
var _default = MemoSvgCheck;
exports["default"] = _default;